import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsPromotionWidget" */ './SportsPromotionWidget'),
  modules: ['./SportsPromotionWidget'],
  loading: () => <div />
});

export default LoadableWidget;
